'use es6';

import { adClickedEventDeprecation } from './adClickedEventDeprecation';
import { usesCurrentlyInWorkflowProperty } from './usesCurrentlyInWorkflowContactProperty';
import { singleDealSplitDeprecation } from './singleDealSplitDeprecation';
export default {
  adClickedEventDeprecation,
  usesCurrentlyInWorkflowProperty,
  singleDealSplitDeprecation
};